export default class RouteService {
  /**
   * @param {{ state?: any, stateParams?: any, rootScope?: any }} options
   */
  constructor({
    state,
    stateParams,
    rootScope
  }) {
    this.state = state;
    this.stateParams = stateParams;
    this.rootScope = rootScope;
  }
  go(path, to = {}, reload) {
    this.state.go(path, to, reload);
  }

  /**
   * URL for a state, for opening a record in a new tab rather than navigating away.
   * ui-router builds it from the registered route, so it is always an internal URL.
   */
  href(path, params = {}, options = {
    absolute: true
  }) {
    if (!this.state || typeof this.state.href !== 'function') return null;
    return this.state.href(path, params, options);
  }
  params() {
    return this.stateParams;
  }

  /** Name of the ui-router state this view is mounted at, for `reloadParentOnly`. */
  currentStateName() {
    return this.state.current && this.state.current.name;
  }
  rootScopeChange() {
    return this.rootScope;
  }
}